import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModelAccessControlRoutingModule } from './model-access-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ModelAccessLevelComponent } from './model-access-level/model-access-level.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSliderModule} from '@angular/material/slider';
import { MaterialModule } from '../material.module';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOptionModule } from '@angular/material/core';

@NgModule({
  declarations: [
    ModelAccessLevelComponent
  ],
 
  imports: [
    CommonModule,
    ModelAccessControlRoutingModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    MatSliderModule,
    MatSlideToggleModule,
    NgMultiSelectDropDownModule,
     MatSelectModule,
    MatFormFieldModule,
    MatOptionModule,
    
    
  ]
})
export class ModelAccessControlModule { }
